<svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
  <g fill="#888EA8" fill-rule="evenodd">
    <rect width="19.25" height="1.75" rx=".875"/>
    <rect width="19.25" height="1.75" y="6.125" rx=".875"/>
    <rect width="19.25" height="1.75" y="12.25" rx=".875"/>
  </g>
</svg>
